import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../../../lib/supabase'

export default function RecentMembers() {
  const [members, setMembers] = useState([])

  useEffect(() => {
    const fetchMembers = async () => {
      const { data } = await supabase
        .from('supporters').select('*, chapters(name)')
        .eq('club_id', 'a0000000-0000-0000-0000-000000000001')
        .order('joined_at', { ascending: false }).limit(5)
      if (data) setMembers(data)
    }
    fetchMembers()
  }, [])

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-4 sm:p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold">Recent Registrations</div>
        <Link to="/admin/members" className="text-xs text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 uppercase tracking-widest font-semibold transition-colors">
          View All
        </Link>
      </div>
      <div className="overflow-x-auto -mx-4 sm:mx-0">
        <div className="min-w-[480px] px-4 sm:px-0">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 dark:border-white/10">
                {['Member ID', 'Name', 'Chapter', 'Status', 'Joined'].map((h) => (
                  <th key={h} className="text-left py-3 px-2 text-xs text-gray-500 uppercase tracking-widest font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member.id} className="border-b border-gray-200 dark:border-white/5">
                  <td className="py-3 px-2 font-black text-green-600 dark:text-green-400 text-xs tracking-wider whitespace-nowrap">{member.membership_id}</td>
                  <td className="py-3 px-2 font-semibold text-gray-900 dark:text-white whitespace-nowrap">{member.full_name}</td>
                  <td className="py-3 px-2 text-gray-500 whitespace-nowrap">{member.chapters?.name || 'N/A'}</td>
                  <td className="py-3 px-2">
                    <span className="bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 text-xs font-bold uppercase tracking-widest px-2 py-1 whitespace-nowrap">
                      {member.status}
                    </span>
                  </td>
                  <td className="py-3 px-2 text-gray-500 text-xs whitespace-nowrap">
                    {new Date(member.joined_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}